import React from 'react';
import LoggedInFooter from './LoggedInFooter';
import LoggedOutFooter from './LoggedOutFooter';

type Props = {
  token: string | null;
};

function ActionsFooter({ token }: Props) {
  return token ? <LoggedInFooter token={token} /> : <LoggedOutFooter />;
}

export default ActionsFooter;
